<template>
<div class='slide-assessment_statebox'>
  <!-- First attempt, user sees primary instructions -->
  <template v-if='status === "started"'>
    <div class='slide-assessment_statebox_instructions'>
      <div
        v-for='(instruction, index) in state_box.instructions'
        :key='index'
        class='slide-assessment_statebox_instruction'
      >
        <div class='slide-assessment_statebox_instruction-headline body-one'>
          {{ instruction.headline }}
        </div>

        <div
          class='slide-assessment_statebox_instruction-subheadline body-one'
          v-html='instruction.subheadline'
        />
      </div>
    </div>

    <a
      v-if='has_attempt'
      class='slide-assessment_statebox-link button-one-branded'
      href='#'
      @click.prevent='assessmentStart'
    >
      {{ button_text }}
    </a>
  </template>

  <!-- Second attempt, user sees another instructions -->
  <template v-if='status === "passed" || status === "failed" || status === "retrying"'>
    <div class='slide-assessment_statebox_step2'>
      <div class='slide-assessment_statebox_step2-left'>
        <div class='slide-assessment_statebox_instruction-headline body-one'>
          {{ state_box_result.headline }}
        </div>

        <div
          class='slide-assessment_statebox_instruction-subheadline body-one'
          v-html='state_box_result.text'
        />

        <!-- Begin Button -->
        <a
          v-if='has_attempt'
          class='slide-assessment_statebox-link button-one-branded'
          href='#'
          @click.prevent='assessmentStart'
        >
          {{ button_text }}
        </a>

        <!-- Contact Support -->
        <a
          v-if='state_box_result.link'
          :href='state_box_result.link.href'
          class='body-two slide-assessment_statebox_results-link'
          target='_blank'
        >
          {{ state_box_result.link.title }}
        </a>
      </div>

      <!-- Results box -->
      <div class='slide-assessment_statebox_step2-right'>
        <div
          class='slide-assessment_statebox_results'
          :class='current_result'
        >
          <div
            v-if='show_attempt_number'
            class='slide-assessment_statebox_results-headline body-four'
          >
            {{ $t('attempt') }} {{ current_attempt }}
          </div>

          <div
            v-if='score'
            class='slide-assessment_statebox_results-percent'
          >
            {{ score }}<span>%</span>
          </div>

          <a
            href='#'
            class='slide-assessment_statebox_results-review link-two'
            @click.prevent='viewResults'
          >
            {{ $t('review_your_answers') }}
          </a>
        </div>
      </div>
      <!-- Results box end -->
    </div>
  </template>
</div>
</template>

<script>
export default {
  props: {
    assessmentStart: Function,
    toggleActivityOverlay: Function,
    activity: Object,
    slide_result: Object
  },

  computed: {
    state_box() {
      return this.activity.state_box
    },

    has_attempt() {
      return this.activity.has_attempt
    },

    status() {
      return this.activity.status
    },

    current_attempt() {
      if (this.slide_result.results) {
        return this.slide_result.results.attempts ? this.slide_result.results.attempts.filter((a) => a.passed !== null).length : 1
      } else return 1
    },

    show_attempt_number() {
      return this.activity.multiple_attempts
    },

    current_result() {
      if (this.activity.previous_attempt) {
        return this.activity.previous_attempt.passed ? 'passed' : 'failed'
      } else {
        return this.status
      }
    },

    score() {
      return '' + this.activity.previous_attempt.score
    },

    button_text() {
      if (this.current_result === 'started') {
        return this.state_box.cta || this.$t('begin')
      } else {
        return this.$t('begin') + ' ' + this.$t('attempt') + ' ' + (this.current_attempt + 1)
      }
    },

    state_box_result() {
      if (this.current_result === 'passed') {
        return this.state_box.results.passed
      } else if (this.current_result === 'failed' && !this.has_attempt) {
        return this.state_box.results.failed_max
      } else if (this.current_result === 'failed') {
        return this.state_box.results.failed
      }
      return null
    }
  },

  methods: {
    viewResults() {
      this.toggleActivityOverlay({ showAssessmentResults: true })
    }
  }
}
</script>

<style lang='sass' scoped>
@import './state-box'
</style>
